export const GET_USERS = "GET_USERS";
export const GET_LIST_USERS = "GET_LIST_USERS";
export const GET_USER = "GET_USER";
export const SET_USERS = "SET_USERS";
export const SET_LIST_USERS = "SET_LIST_USERS";
export const SET_ONE_USER = "SET_ONE_USER";
export const ADD_USER = "ADD_USER";
export const SET_NEW_USER = "SET_NEW_USER";
export const EDIT_USER = "EDIT_USER";
export const SET_EDIT_USER = "SET_EDIT_USER";
export const SET_DELETE_USER = "SET_DELETE_USER";
export const SET_DELETE_MULTI_USER = "SET_DELETE_MULTI_USER";
export const DELETE_USER = "DELETE_USER";
export const DELETE_MULTI_USER = "DELETE_MULTI_USER";
export const RESET_ITEMS_USER = "RESET_ITEMS_USER";
export const RESET_SELECTED_USER = "RESET_SELECTED_USER";
export const RESET_LIST_USERS = "RESET_LIST_USERS";
export const SET_EDIT_PROFILE = "SET_EDIT_PROFILE";
export const SET_PASSWORD_CHANGE = "SET_PASSWORD_CHANGE";
export const SET_USER_TOKEN = "SET_USER_TOKEN";
export const RESET_USER_TOKEN = "RESET_USER_TOKEN";
